export * from './platform/default';

const PAIRING_METHOD_KEY = 'pairing_method';

export const getPairingMethod = () => localStorage.getItem(PAIRING_METHOD_KEY);

export const setPairingMethod = value => localStorage.setItem(PAIRING_METHOD_KEY, value);
